import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavModules } from '@app/shared/components/nav-modules/nav-modules';

@Component({
  selector: 'app-app-layout',
  imports: [NavModules, RouterOutlet],
  templateUrl: './app-layout.html',
  styleUrl: './app-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppLayout {}
